import { render, staticRenderFns } from "./EasMigration.vue?vue&type=template&id=028ace13&scoped=true"
import script from "./EasMigration.vue?vue&type=script&lang=js"
export * from "./EasMigration.vue?vue&type=script&lang=js"
import style0 from "./EasMigration.vue?vue&type=style&index=0&id=028ace13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ace13",
  null
  
)

export default component.exports